import KUSPIT_TYPES from './kuspit/types';
import ALLIANZ_TYPES from './allianz/types';

export default {
  ...KUSPIT_TYPES,
  ...ALLIANZ_TYPES,
};
